import React from 'react';
import { Helmet } from 'react-helmet-async';
import Footer from '../Components/Footer';
import Header from '../Components/Header';
import aboutBanner from '../assests/img/lab-about.jpg';

import about1 from '../assests/img/about-us.png';
import about2 from '../assests/img/about02.jpg';

function Aboutpage() {
  return (
    <div>
      <Helmet>
        <title>About Labway Scientific</title>
        <meta
          name="description"
          content="Learn more about Labway Scientific, manufacturer and exporter of scientific laboratory instruments, educational apparatus, and science kits."
        />
        <meta
          name="keywords"
          content="Labway Scientific, laboratory instruments, science kits, educational apparatus, manufacturer, exporter"
        />
      </Helmet>

      <Header />

      <div className="container">
        <div className="about-banner">
          <img src={aboutBanner} alt="About Labway Scientific" />
        </div>
      </div>

      <div className="container main-contant">
        <div className="inner-page-container">
          <div className="about-page-content">
            <h1 className="page-title">About Labway</h1>

            <div className="about-intro">
              <h4 className="about-intro-title">
                "LABWAY" is recognized as a leading and reliable manufacturer
                and exporter of scientific laboratory instruments, science and
                math kits, and educational apparatus.
              </h4>
            </div>

            <div className="entry-content">
              <div className="row about-section align-items-center">
                <div className="col-lg-7">
                  <div className="about-copy">
                    <p>
                      "LABWAY" aims to provide the best, most engaging, and
                      innovative science and educational products. "LABWAY" has
                      been producing and selling equipment used in schools,
                      colleges, training institutes, and laboratories.
                    </p>
                    <p>
                      The product range has now grown to more than 2000 units
                      and systems. It is constantly being updated and expanded
                      with new equipment. This allows us to cover all aspects of
                      training in education-related areas. We also welcome
                      custom designs according to end-user specifications and
                      requirements.
                    </p>
                    <p>
                      Our mission is to supply only the best quality products to
                      our customers at the best price. Through hard work and
                      continuous effort, we have achieved this and continue
                      striving to keep our customers happy at all times.
                    </p>
                  </div>
                </div>

                <div className="col-lg-5">               
                    <img
                      fetchPriority="high"
                      decoding="async"
                      src={about1} 
                      alt="About Labway"
                      className="about-section-image"
                    />                 
                </div>
              </div>

              <div className="row about-section about-section-alt align-items-center">
                <div className="col-lg-5">
               
                    <img
                      decoding="async"
                       src={about2} 
                      alt="Labway products"
                      className="about-section-image"
                    />
                 
                </div>

                <div className="col-lg-7">
                  <div className="about-copy about-copy-highlight">
                    <div className="about-copy-block">
                      <h4>The right choice!</h4>
                      <p>
                        "LABWAY" is the ultimate choice. You no longer need to
                        go elsewhere. We supply everything from primary school
                        science kits, lab glassware and consumables, teaching
                        aids, physics equipment, chemicals, and much more. Each
                        item is carefully selected to maintain international
                        standards while remaining easy to use, affordable, and
                        engaging.
                      </p>
                    </div>

                    <div className="about-copy-block">
                      <h4>The best service!</h4>
                      <p>
                        It is easy to place your order with "LABWAY" by fax,
                        phone, or email. If you have any queries related to your
                        order, our dedicated customer service team is always
                        available to help. We are fully committed to serving our
                        valued customers with care and attention.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row about-section about-bottom-section">
                <div className="col-md-12">
                  <div className="about-bottom-card">
                    <h4>For fast delivery!</h4>
                    <p>
                      We understand that sometimes you may need items urgently.
                      "LABWAY" has invested heavily in stock and now carries
                      more items than ever before, allowing us to dispatch
                      complete orders faster.
                    </p>
                    <p>
                      Our team always ensures that products are as user-friendly
                      as possible and durable enough to withstand repeated
                      classroom and technical training use.
                    </p>
                    <p>
                      All products and systems are thoroughly tested before
                      packing and delivery to ensure smooth performance. Service
                      plays a key role in our day-to-day dealings with
                      customers, and we aim to provide dependable support at
                      every step.
                    </p>

                    <h4>Our Motto!</h4>
                    <p>
                      Our motto is end-user satisfaction. In the future, others
                      may match products or prices, but a strong
                      customer-service culture cannot be easily copied.
                    </p>
                    <p>
                      Our sales are not something we chase. They happen
                      naturally while we remain deeply committed to serving our
                      customers.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Aboutpage;
